import React from 'react';

import { UiSigninLayout } from '../../common/UiLogin';
import {
    Features,
    useFeatureFlagValue,
} from '../../util/FeatureFlagUtil';
import BillboardComponent from './subcomponents/BillboardComponent';
import SigninComponent from './subcomponents/SigninComponent';

const LoginPageComponent = () => {

    const { EnableBillBoard } = useFeatureFlagValue([ Features.EnableBillBoard ]);

    return <UiSigninLayout
        left={<SigninComponent />}
        right={<BillboardComponent />}
        showBillboard={EnableBillBoard} />;
};

export default LoginPageComponent;
